import React from 'react';

import css from './PressReleases.module.scss';

import data from './data.json';

const PressReleases = () => {
	return (
		<section className={css.pressRelease}>
			<h4 className="textGreen">Press Releases</h4>
			<div className={css.contentWrapper}>
				{data.map(({ heading, author, date, link }) => (
					<div className={css.card}>
						<h5>
							<a href={link} target="_blank" rel="noopener noreferrer">
								{heading}
							</a>
						</h5>
						<div className={css.meta}>
							<span className={css.author}>by {author}</span>
							<span className={css.date}>{date}</span>
						</div>
					</div>
				))}
			</div>
		</section>
	);
};

export default PressReleases;
